/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Validation_Invalid_Recovery_CodeInputs */



/**
* | output |
* | --- |
* | "Invalid recovery code format" |
*
* @param {Form_Validation_Invalid_Recovery_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_invalid_recovery_code = /** @type {((inputs?: Form_Validation_Invalid_Recovery_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Invalid_Recovery_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges Format für Wiederherstellungscode")
	return /** @type {LocalizedString} */ ("Invalid recovery code format")
});